function getTitle(lang){
    let titulos = [];
    if(lang === 'es'){
        titulos =  ['Ingeniero','Papá','Fotógrafo','Artista Marcial','Maker','Carpintero','Soldador al arco','Programador',
                    'Ingeniero de TV','Ingeniero de Software','Maquetista','Coleccionista','INTP','Ciclista','Capitán de velero RC'];
    }else{
        titulos =  ['Engineer','Dad','Photographer','Marcial artist','Maker','Carpenter','Arc welder','Programmer',
        'TV engineer','Software engineer','Model maker','Collector','INTP','Biker','RC sailboat captain'];
    }
    let tamanoArreglo = titulos.length;
    return titulos[Math.floor( Math.random()*tamanoArreglo)];
};

function getOddjobs(lang){
    let oddjobs = [];
    if(lang === 'es'){
        oddjobs = ['haciendo planillas de excel','escribiendo programas','haciendo fotografía','practicando kungfú','haciendo taichi',
        'diseñando en CAD','soldando al arco','escribiendo en PHP','escribiendo en Python','escribiendo HTML','construyendo maquetas',
        'coleccionando cosas','elaborando una gantt','pintando con aerógrafo','leyendo un libro','escribiendo algo de poco interés',
        'hablando sobre acorazados','volando el drone','imprimiendo en 3D','cepillando una tabla','tocando la guitarra','paseando a los hijos','paseando al perro',
        'haciendo el almuerzo','practicando boxeo','configurando backoffices de TV','editando videos','administrando AWS','enviando comandos a Openshift',
        'atendiendo reuniones','pensando en otras cosas','distraído','turisteando','estudiando historia naval',
        'viendo videos de barcos antiguos','andando en bici','en una regata RC','diseñando un mueble','haciendo experimentos','usando el taladro',
        'bajando el cerro en bici','haciendo downhill','haciendo pesas','echando a perder algo','arreglando algo','quemando un circuito',
        'levantando a los hijos','acostando a los hijos','estudiando','caminando por ahí','entendiendo como funciona algo',
        'explicando como funciona algo','tomando café','viendo la F1','editando una foto'];
    }else{
        oddjobs = ['making excel spreadsheets','programming','doing photography','practicing kungfu','practicing taichi',
        'designing in CAD','arc welding','programming in PHP','programming in Python','writing HTML','building models',
        'collecting things','makinga a gantt','airbrushing','reading a book','writing uninteresting things',
        'talking about battleships','flying the drone','3D printing','planing a board','playing the guitar','walking the kids','walking the dog',
        'making lunch','practicing boxing','configuring TV backoffices','editing videos','managing AWS','managing Openshift',
        'attending meetings','thinking on something else','distracted','sightseeing','wandering around','studying naval story',
        'watching old ships videos','biking','at a RC regatta','designing furniture','making experiments','using the drill',
        'going downhill on the bike','doing downhill','at the gym','ruining something','fixing something','burning a circuit',
        'waking up the kids','taking the kids to bed','studying','understanding how something works',
        'explaining how something works','drinking coffee','watching F1','Editing a picture'];
    }
    let tamanoArreglo = oddjobs.length;
    return oddjobs[Math.floor( Math.random()*tamanoArreglo)];
};

export function getBajada(lang){
    return getTitle(lang)+" "+getOddjobs(lang);
}